<template>
  <WebsiteLayout>
    <VLayout>
      <VContainer>
        <h1 class="display-1 text--primary">
          Impressum
        </h1>
        <div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. A accusamus ad aliquam at deleniti
            distinctio eum, ex
            excepturi fugit impedit, itaque molestias obcaecati omnis perspiciatis possimus sapiente sunt
            veritatis
            voluptas.
          </p>
          <p>
            Cumque, debitis ducimus est eum quae quaerat quia saepe voluptas. Alias aliquam doloremque eum ex
            illum
            mollitia
            nam nesciunt non tempora! Accusamus dignissimos ex facilis illo itaque nemo quasi, rerum.
          </p>
          <p>
            Eos neque praesentium provident. Aperiam commodi, distinctio dolorem doloribus hic illum inventore
            ipsam
            maiores
            nihil, odit qui rem veniam, voluptas. Ab aliquid autem dignissimos doloremque in itaque iusto quo,
            sed.
          </p>
          <p>
            Error iure nobis officiis optio perferendis ratione sint? Accusamus deserunt dignissimos earum, est
            harum iure
            libero magnam neque nobis nulla optio provident qui quidem quo repellendus sint soluta vitae!
            Ipsum.
          </p>
          <p>
            Aperiam, blanditiis corporis eligendi esse est et itaque magnam neque officia quos recusandae
            repellat?
            Corporis
            error modi nam suscipit unde. Esse maxime pariatur rerum! Animi culpa ea facilis illo ipsa!
          </p>
        </div>
      </VContainer>
    </VLayout>
  </WebsiteLayout>
</template>

<script>

export default {
  name: 'Imprint'
}
</script>

<style scoped>

</style>
